import { render, staticRenderFns } from "./StudentBottomNav.vue?vue&type=template&id=51f0174e&scoped=true&"
import script from "./StudentBottomNav.vue?vue&type=script&lang=js&"
export * from "./StudentBottomNav.vue?vue&type=script&lang=js&"
import style0 from "./StudentBottomNav.vue?vue&type=style&index=0&id=51f0174e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f0174e",
  null
  
)

export default component.exports